module.exports = "<p>\r\n  rider-payor-detail-grid works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/rider/components/rider-payor-detail-grid/rider-payor-detail-grid.component.html
// module id = 2515
// module chunks = 66